import { Component, input } from '@angular/core';
import { OnyxTooltipDirective } from '../../../directives/onyx-tooltip.directive';
import type {
  OnyxTooltipColor,
  OnyxTooltipConfig,
} from '../../../internal/components/onyx-tooltip-overlay/onyx-tooltip-overlay.component';
import { OnyxIconComponent } from '../../icons/onyx-icon/onyx-icon.component';
import type { OnyxTooltipContext } from '../interfaces';

@Component({
  selector: 'onyx-tooltip',
  imports: [OnyxTooltipDirective, OnyxIconComponent],
  templateUrl: './onyx-tooltip.component.html',
  styleUrls: ['./onyx-tooltip.component.scss'],
})
export class OnyxTooltipComponent {
  public readonly tooltip = input.required<OnyxTooltipContext>();
  public readonly color = input<OnyxTooltipColor>('black');
  public readonly showArrow = input(true);
  public readonly textAlign = input<OnyxTooltipConfig['textAlign']>('center');
  public readonly delay = input(0);
  public readonly disabled = input<boolean | (() => boolean)>(false);
  public readonly size = input(16);
}
